import styled from 'styled-components';

import { OfferImagePositionEnum, OfferPaymentImage } from 'features/offers/types';
import { getImageLayout } from '../../layouts';
import { useOffers } from 'features/offers';

export const LeftLayout = styled('img')`
  display: block;
`;

const Left = () => {
  const {
    buyInformation: { offerImages, offerImageLayout },
  } = useOffers();

  const imageLayout = getImageLayout(offerImageLayout);

  const image = offerImages
    .filter((image) => image.position === OfferImagePositionEnum.Left)
    .reduce((_, image) => image, {} as OfferPaymentImage);

  if (imageLayout?.left && image?.imageUrl) {
    return (
      <LeftLayout
        src={image.imageUrl}
        width={imageLayout.left.width}
        height={imageLayout.left.height}
      />
    );
  }

  return <></>;
};

export default Left;
